/* Cart exit offer popup — Kalles
   Idle cost: one click listener. Markup is cloned from a <template>, CSS is loaded
   only when the popup opens, and the cart is fetched only when the drawer is closed. */
(() => {
  const tpl = document.getElementById('ceo-template');
  if (!tpl || window.__ceoReady) return;
  window.__ceoReady = true;

  const KEY = 'ceo_done';
  const cfg = tpl.dataset;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const minutes = Number(cfg.minutes) || 3;
  const autoplayMs = (Number(cfg.autoplay) || 3) * 1000;
  const cartUrl = cfg.cartUrl || '/cart';
  const rootUrl = (cfg.rootUrl || '/').replace(/\/$/, '');

  let root = null;
  let cards = [];
  let revealBox = null;
  let queue = [];
  let idx = -1;
  let endAt = 0;
  let tick = null;
  let revealTimer = null;
  let carousel = null;
  let busy = false;

  const isDone = () => sessionStorage.getItem(KEY) === '1';
  const markDone = () => sessionStorage.setItem(KEY, '1');
  const afterUrl = () => (cfg.after === 'checkout' ? '/checkout' : cartUrl);
  const goTo = (url) => { window.location.href = url; };

  const track = (name, data) => {
    try {
      window.dataLayer && window.dataLayer.push(Object.assign({ event: name }, data));
      window.fbq && window.fbq('trackCustom', name, data);
    } catch (e) { /* analytics must never break the popup */ }
  };

  const postJSON = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then((r) => { if (!r.ok) throw new Error('cart_failed'); return r.json(); });

  const loadCSS = (href, id) => new Promise((resolve) => {
    if (document.getElementById(id)) { resolve(); return; }
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = resolve;
    document.head.appendChild(link);
  });

  const drawerIsOpen = () => {
    const d = document.querySelector(cfg.drawer);
    if (!d) return false;
    const r = d.getBoundingClientRect();
    const cs = getComputedStyle(d);
    return r.width > 0 && r.left < window.innerWidth - 10 && r.right > 10 &&
      cs.visibility !== 'hidden' && cs.display !== 'none';
  };

  const codeApplied = (cart, code) => {
    const c = code.toLowerCase();
    const title = (d) => (d && d.title ? d.title.toLowerCase() : '');
    return (cart.cart_level_discount_applications || []).some((d) => title(d) === c) ||
      (cart.items || []).some((it) => (it.line_level_discount_allocations || [])
        .some((a) => title(a.discount_application) === c));
  };

  /* ---------- mount (first open only) ---------- */
  async function mount() {
    if (root) return;
    const loads = [loadCSS(cfg.css, 'ceo-css')];
    if (cfg.font === 'true') loads.push(loadCSS('https://fonts.googleapis.com/css2?family=Alexandria:wght@700;900&display=swap', 'ceo-font'));
    document.body.appendChild(tpl.content.cloneNode(true));
    root = document.getElementById('ceo-root');
    if (cfg.font === 'true') root.style.setProperty('--ceo-display', "'Alexandria', sans-serif");
    cards = Array.from(root.querySelectorAll('.ceo__card'));
    revealBox = root.querySelector('[data-reveal-box]');
    root.addEventListener('click', onPopupClick);
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });
    // أسعار البوب أب جوه span.money: نطلب من محوّل العملات في Kalles يحوّلها لعملة الدولة
    if (window.jQuery) window.jQuery(document).trigger('currency:update');
    await loads[0];
  }

  /* ---------- trigger: customer closes the cart drawer ---------- */
  document.addEventListener('click', async (e) => {
    if (!e.target.closest(cfg.close)) return;
    if (isDone() || busy || !drawerIsOpen()) return;
    busy = true;
    try {
      const cart = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (!cart.item_count) return;
      await mount();
      const inCart = new Set(cart.items.map((it) => String(it.product_id)));
      queue = cards.filter((c) => {
        if (c.dataset.type === 'products') {
          const items = Array.from(c.querySelectorAll('[data-item]'));
          items.forEach((el) => { el.hidden = inCart.has(el.dataset.productId); });
          return items.some((el) => !el.hidden);
        }
        if (c.dataset.type === 'coupon') return !codeApplied(cart, c.dataset.code);
        return false;
      });
      if (!queue.length) return;
      markDone();
      open();
    } catch (err) {
      /* fail silently, the store keeps working */
    } finally {
      busy = false;
    }
  }, true);

  function open() {
    root.hidden = false;
    document.documentElement.classList.add('ceo-lock');
    if (cfg.reveal === 'true' && revealBox) {
      revealBox.hidden = false;
      track('exit_offer_reveal', {});
      revealTimer = setTimeout(() => { revealBox.hidden = true; show(0); }, reduceMotion ? 900 : 1500);
    } else {
      show(0);
    }
  }

  function show(i) {
    clearInterval(tick);
    if (carousel) { carousel.stop(); carousel = null; }
    cards.forEach((c) => { c.hidden = true; c.classList.remove('is-low'); });
    const card = queue[i];
    if (!card) { close(); return; }
    idx = i;
    card.hidden = false;
    if (card.dataset.type === 'products') carousel = setupCarousel(card);
    endAt = Date.now() + minutes * 60000;
    renderTimer(card);
    tick = setInterval(() => renderTimer(card), 1000);
    const focusEl = card.querySelector('[data-add], [data-apply]');
    if (focusEl) focusEl.focus({ preventScroll: true });
    track('exit_offer_shown', { step: card.dataset.step, type: card.dataset.type });
  }

  function renderTimer(card) {
    const left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
    card.querySelector('[data-mm]').textContent = String(Math.floor(left / 60)).padStart(2, '0');
    card.querySelector('[data-ss]').textContent = String(left % 60).padStart(2, '0');
    card.classList.toggle('is-low', left > 0 && left <= 30);
    if (left === 0) {
      track('exit_offer_expired', { step: card.dataset.step, type: card.dataset.type });
      close();
    }
  }

  function close() {
    clearInterval(tick);
    clearTimeout(revealTimer);
    if (carousel) { carousel.stop(); carousel = null; }
    root.hidden = true;
    if (revealBox) revealBox.hidden = true;
    cards.forEach((c) => { c.hidden = true; });
    document.documentElement.classList.remove('ceo-lock');
  }

  /* ---------- carousel ---------- */
  function setupCarousel(card) {
    const trackEl = card.querySelector('[data-track]');
    const dotsEl = card.querySelector('[data-dots]');
    const items = Array.from(trackEl.querySelectorAll('[data-item]')).filter((el) => !el.hidden);
    let timer = null;
    let paused = false;
    let active = 0;

    dotsEl.textContent = '';
    const dots = items.length > 2 ? items.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ceo__dot';
      b.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
      b.addEventListener('click', () => { goToItem(i); restart(); });
      dotsEl.appendChild(b);
      return b;
    }) : [];

    const step = () => (items[1] ? Math.abs(items[1].offsetLeft - items[0].offsetLeft) : 1);
    const atEnd = () => Math.abs(trackEl.scrollLeft) + trackEl.clientWidth >= trackEl.scrollWidth - 4;

    function paint() {
      active = Math.min(items.length - 1, Math.round(Math.abs(trackEl.scrollLeft) / step()));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
    }
    function goToItem(i) {
      if (!items[i]) return;
      trackEl.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function next() {
      if (!paused) goToItem(atEnd() ? 0 : active + 1);
    }
    function restart() {
      clearInterval(timer);
      if (!reduceMotion && items.length > 2) timer = setInterval(next, autoplayMs);
    }
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };

    trackEl.onscroll = paint;
    trackEl.onpointerenter = pause;
    trackEl.onpointerleave = resume;
    trackEl.ontouchstart = pause;
    trackEl.ontouchend = resume;
    trackEl.onfocusin = pause;
    trackEl.onfocusout = resume;

    trackEl.scrollLeft = 0;
    paint();
    restart();
    return { stop: () => clearInterval(timer) };
  }

  /* ---------- one discounted piece per customer ---------- */
  function setContinue(card) {
    const btn = card.querySelector('[data-continue]');
    const picked = card.querySelector('[data-item].is-added');
    btn.disabled = !picked;
    btn.textContent = picked ? btn.dataset.labelSome : btn.dataset.labelNone;
  }

  function setItemState(item, added, variantId) {
    const btn = item.querySelector('[data-add]');
    const select = item.querySelector('select[data-variant]');
    item.classList.toggle('is-added', added);
    btn.setAttribute('aria-pressed', String(added));
    btn.textContent = added ? btn.dataset.addedText : btn.dataset.addText;
    if (select) select.disabled = added;
    if (added) item.dataset.variantAdded = variantId;
    else delete item.dataset.variantAdded;
  }

  async function removeItem(item) {
    await postJSON(cfg.cartChangeUrl + '.js', { id: String(item.dataset.variantAdded), quantity: 0 });
    track('exit_offer_item_removed', { variant_id: item.dataset.variantAdded });
    setItemState(item, false);
  }

  async function toggleItem(card, addBtn) {
    const item = addBtn.closest('[data-item]');
    const errorEl = card.querySelector('[data-error]');
    const buttons = card.querySelectorAll('[data-add]');
    buttons.forEach((b) => { b.disabled = true; });
    errorEl.hidden = true;
    try {
      if (item.classList.contains('is-added')) {
        await removeItem(item);
      } else {
        const previous = card.querySelector('[data-item].is-added');
        if (previous) await removeItem(previous);
        const variantId = item.querySelector('[data-variant]').value;
        await postJSON(cfg.cartAddUrl + '.js', { items: [{ id: Number(variantId), quantity: 1 }] });
        setItemState(item, true, variantId);
        track('exit_offer_item_added', { variant_id: variantId });
      }
      setContinue(card);
    } catch (err) {
      errorEl.textContent = errorEl.dataset.msg;
      errorEl.hidden = false;
    } finally {
      buttons.forEach((b) => { b.disabled = false; });
    }
  }

  /* ---------- clicks inside the popup ---------- */
  async function onPopupClick(e) {
    if (e.target.closest('[data-ceo-dismiss]')) {
      const c = queue[idx];
      track('exit_offer_dismissed', c ? { step: c.dataset.step, type: c.dataset.type } : {});
      close();
      return;
    }

    const card = queue[idx];
    if (!card || card.hidden) return;
    const meta = { step: card.dataset.step, type: card.dataset.type };

    const addBtn = e.target.closest('[data-add]');
    if (addBtn) { toggleItem(card, addBtn); return; }

    if (e.target.closest('[data-continue]')) {
      track('exit_offer_accepted', meta);
      close();
      goTo(afterUrl());
      return;
    }

    if (e.target.closest('[data-decline]')) {
      track('exit_offer_declined', meta);
      if (card.querySelector('.is-added')) { close(); goTo(afterUrl()); return; }
      show(idx + 1);
      return;
    }

    const copyBtn = e.target.closest('[data-copy]');
    if (copyBtn) {
      try { await navigator.clipboard.writeText(card.dataset.code); } catch (err) { /* clipboard blocked */ }
      copyBtn.textContent = copyBtn.dataset.copied;
      track('exit_offer_code_copied', meta);
      return;
    }

    if (e.target.closest('[data-apply]')) {
      track('exit_offer_accepted', meta);
      close();
      goTo(rootUrl + '/discount/' + encodeURIComponent(card.dataset.code) + '?redirect=' + encodeURIComponent(afterUrl()));
    }
  }
})();
